import React from 'react';
import './CustomButton.css';

const CustomButton = ({ 
    onClick, 
    disabled = false, 
    children, 
    className = '',
    style = {} 
}) => {
    return (
        <button
            className={`custom-generate-button ${disabled ? 'disabled' : ''} ${className}`}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            style={style}
        >
            {children}
        </button>
    );
};

export default CustomButton;
